import { MigrateActions, EMigrateActions, StartStatusDetectionSuccess, SetStatus, SetProgress } from './../actions/migrate.actions';

export const initialMigrateStakeholdersState: IMigrateStakeholders = {
  progress: {
    currentBatch: 0,
    currentPercentage: 0,
    totalBatches: 0,
    totalUsersProcessed: 0,
    totalUsersProcessing: 0,
    totalUsersToProcess: 0
  },
  status: '',
  errors: []
};

export function MigrateReducer(
  state = initialMigrateStakeholdersState,
  action: MigrateActions
): IMigrateStakeholders {
  switch (action.type) {
    case EMigrateActions.START_STATUS_DETECTION_SUCCESS: {
      let response = (action as StartStatusDetectionSuccess).payload;
      let progress = response.progress;
      let status = response.status;

      return {
        ...state,
        progress,
        status
      };
    }

    case EMigrateActions.RESET_STATUS_DETECTION: {
      return {
        ...state,
        status : ''
      };
    }

    case EMigrateActions.SET_STATUS: {
      return {
        ...state,
        status : (action as SetStatus).payload
      };
    }

    case EMigrateActions.SET_PROGRESS: {
      return {
        ...state,
        progress : (action as SetProgress).payload
      };
    }

    default: {
      return state;
    }
  }
}
